$('.slider-v1').slick({
    slidesToShow: 4,
    infinite: false,
    arrows: false,
    touchThreshold: 50,
    responsive: [
        {
            breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
        }
    ]
});

window.addEventListener("load", () => {
  setTimeout(() => {
    const lenis = new Lenis({
        lerp: 0.1,
        smooth: true,
    })

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

  }, 300) // 300ms delay – tweak if needed
})
